export enum AccountSettingsActionsType {
    LOAD_ACCOUNT_SETTINGS = "ACTIONS_SETTINGS/LOAD_ACCOUNT_SETTINGS",
    SET_ACCOUNT_SETTINGS = "ACTIONS_SETTINGS/SET_ACCOUNT_SETTINGS",
    UPDATE_ACCOUNT_CURRENCY_SETTINGS = "ACTIONS_SETTINGS/UPDATE_ACCOUNT_CURRENCY_SETTINGS",
}
